/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;



//////////////////
// WEBPACK FOOTER
// ./~/victory-voronoi/~/lodash/_listCacheClear.js
// module id = ./node_modules/victory-voronoi/node_modules/lodash/_listCacheClear.js
// module chunks = 1